import { Button } from '@repo/ui/components/ui/button'
import { Callout } from '@repo/ui/components/ui/callout'
import { createFileRoute } from '@tanstack/react-router'
import { DocumentRouteShell } from '@/components/app/route-shells'
import type { RouteStaticData } from '@/lib/router/breadcrumbs'
import { trpc } from '@/lib/trpc'

export const Route = createFileRoute('/_app/admin/audit')({
  component: AdminAuditPage,
  staticData: {
    breadcrumbs: [{ label: 'Audit Logs' }],
  } satisfies RouteStaticData,
})

function AdminAuditPage() {
  const auditStats = trpc.admin.audit.stats.useQuery()
  const stats = auditStats.data as
    | {
        message?: string
        totalEvents?: number
        uniqueActors?: number
        criticalEvents?: number
      }
    | undefined

  return (
    <DocumentRouteShell>
      {auditStats.isError ? (
        <Callout>
          <p className="text-sm text-muted-foreground">
            Failed to load audit integration. {(auditStats.error as unknown as Error).message}
          </p>
          <Button asChild variant="outline" size="sm" className="mt-3">
            <a href="https://logs.betterstack.com/" target="_blank" rel="noopener noreferrer">
              Open Better Stack
            </a>
          </Button>
        </Callout>
      ) : (
        <Callout>
          {auditStats.isLoading ? (
            <p className="text-sm text-muted-foreground">Loading audit integration...</p>
          ) : (
            <div className="space-y-2 text-sm text-muted-foreground">
              <p>{stats?.message || 'Audit events will appear here as admin activity occurs.'}</p>
              <p>
                Events: {stats?.totalEvents ?? 0} · Actors: {stats?.uniqueActors ?? 0} · Critical:{' '}
                {stats?.criticalEvents ?? 0}
              </p>
            </div>
          )}
        </Callout>
      )}
    </DocumentRouteShell>
  )
}
